import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferStack } from '../components/OfferStack';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CloseSection } from '../components/CloseSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-body text-brown selection:bg-sage/30" data-id="element-208">
      <UrgencyBar data-id="element-209" />
      <main data-id="element-210">
        <HeroSection data-id="element-211" />
        <StorySection data-id="element-212" />
        <TestimonialsSection data-id="element-213" />
        <OfferStack data-id="element-214" />
        <PricingSection data-id="element-215" />
        <FAQSection data-id="element-216" />
        <GuaranteeSection data-id="element-217" />
        <CloseSection data-id="element-218" />
      </main>
      <Footer data-id="element-219" />
      <RecentPurchaseToast data-id="element-220" />
    </div>;
}